import {IHttpPromise, IHttpService} from "angular";
import {Page, Pageable} from "../../utils/models/Page";
import {Partner} from "../model/Partner";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {SendGridContactListOptions} from "../../customers/model/SendGridContactListOptions";
import {ContactFilter} from "../../contact/model/ContactFilter";
import {IContactService} from "../../contact/service/IContactService";

export class PartnerService implements IContactService<Partner> {

    static instance = [
        '$http',
        PartnerService
    ]

    constructor(private $http: IHttpService) {
    }


    fetchContacts(filter: ContactFilter, pagingConfig: Pageable): IHttpPromise<Page<Partner>> {
        return this.$http({
            method: 'POST',
            url: getAbsoluteUrl('api/partners/'),
            data: filter,
            params: {
                pageSize: pagingConfig.pageSize,
                pageNumber: pagingConfig.page - 1
            }
        });
    }

    fetchContactDetails(id: number): angular.IPromise<Partner> {
        return this.$http<Partner>({
            method: 'GET',
            url: getAbsoluteUrl(`api/partner/${id}`)
        }).then(r => r.data);
    }

    createSendgridContactsListFromFilteredContacts = (sendGridOptions: SendGridContactListOptions,
                                                      filter: ContactFilter) => this.$http({
        method: 'POST',
        url: getAbsoluteUrl('api/partner/contact_list'),
        data: {
            sendGridOptions: sendGridOptions,
            contactFilter: filter
        },
        params: {
            filtered: true
        }
    });

    createSendgridContactsListFromContactIds = (sendGridOptions: SendGridContactListOptions, ids: number[]) =>
        this.$http({
            method: 'POST',
            url: getAbsoluteUrl('api/partner/contact_list'),
            data: {
                sendGridOptions: sendGridOptions,
                ids: ids
            },
            params: {
                personal: true
            }
        });
}